import { createSlice } from '@reduxjs/toolkit';

const getJsonLocalStorageValue = (key, defaultValue) => {
    let localValue = localStorage.getItem(key);
    if (localValue && localValue !== undefined && localValue !== 'undefined') {
        return JSON.parse(localValue);
    }
    return defaultValue;
};

export const dataSlice = createSlice({
    name: 'data',
    initialState: {
        // badge
        needsBadges: true,
        needsCTBadges: true,
        badgesLoading: false,
        badgeCounts: getJsonLocalStorageValue("badgeCounts", []),
        ctBadgeCounts: getJsonLocalStorageValue("ctBadgeCounts", []),
        selectedBadge: null,
        selectedSection: null,
        selectedBadgeModalActive: false,
        seeAllBadgesModalActive: false,
        walletData: null,
        // challenges
        challengeData: getJsonLocalStorageValue("challengeData", []),
        challengesLoading: false,
        selectedChallenge: null,
        joiningChallenge: false,
        // events
        eventCheckin: false,
        // ct
        ctEncryptedId: localStorage.getItem("ctEncryptedId") ? localStorage.getItem("ctEncryptedId") : "",
        // loading
        userLoading: true,
        rewardsLoading: true,
        // poll
        pollSubmissionSuccess: false,
        pollSubmissionError: "",
        pollSubmissionResults: null,
        // quiz
        quizUserSelections: [],
        quizSubmissionSuccess: false,
        quizSubmissionError: "",
        // rewards
        redeemRewardLoading: true,
        redeemedReward: getJsonLocalStorageValue("redeemedReward", ""),
        redeemedRewardError: getJsonLocalStorageValue("redeemedRewardError", ""),
        // section
        badgeSections: getJsonLocalStorageValue("badgeSections", []),
        ctBadgeSections: getJsonLocalStorageValue("ctBadgeSections", []),
        hasVoting: localStorage.getItem('hasVoting') && localStorage.getItem('hasVoting') === "1" ? true : false,
        rewardSections: getJsonLocalStorageValue("rewardSections", []),
        tabSelected: "overview",
        votingSections: getJsonLocalStorageValue("votingSections", []),
        gamesSections: getJsonLocalStorageValue("gamesSections", []),
        // survey
        surveyNoTextError: false,
        surveySubmissionSuccess: false,
        surveySubmissionError: "",
        surveyUserSelections: [],
        // user
        selectFavTeamModalOpen: false,
        memberSince: null,
        phoneNumber: "",
        termsAndConditions: false,
        invalidPhoneNumber: false,
        userEmail: localStorage.getItem("userEmail"),
        userGuid: localStorage.getItem("userGuid"),
        userName: getJsonLocalStorageValue("userName", null),
        favoriteTeams: getJsonLocalStorageValue("favoriteTeams", []),
        isVIP: getJsonLocalStorageValue("isVIP", false),
        userType: localStorage.getItem("userType") ? localStorage.getItem("userType") : "free member",
        // window
        isMobileView: false,
        windowSize: "large",
        // notif
        showNotification: false,
        notificationBody: null,
    },
    reducers: {
        setTabSelected: (state, action) => {
            state.tabSelected = action.payload
        },
        setUserLoading: (state, action) => {
            state.userLoading = action.payload
        },
        setRewardsLoading: (state, action) => {
            state.rewardsLoading = action.payload
        },
        setNeedsBadges: (state, action) => {
            state.needsBadges = action.payload
        },
        setNeedsCTBadges: (state, action) => {
            state.needsCTBadges = action.payload
        },
        setBadgesLoading: (state, action) => {
            state.badgesLoading = action.payload
        },
        setUserEmail: (state, action) => {
            state.userEmail = action.payload
        },
        setUserGuid: (state, action) => {
            state.userGuid = action.payload
        },
        setFavoriteTeams: (state, action) => {
            localStorage.setItem('favoriteTeams', JSON.stringify(action.payload));
            state.favoriteTeams = action.payload
        },
        setUserName: (state, action) => {
            state.userName = action.payload
        },
        setUserType: (state, action) => {
            state.userType = action.payload
        },
        setRewardSections: (state, action) => {
            state.rewardSections = action.payload
        },
        setVotingSections: (state, action) => {
            state.votingSections = action.payload
        },
        setGamesSections: (state, action) => {
            state.gamesSections = action.payload
        },
        setBadgeSections: (state, action) => {
            state.badgeSections = action.payload
        },
        setCTBadgeSections: (state, action) => {
            state.ctBadgeSections = action.payload
        },
        setBadgeCounts: (state, action) => {
            state.badgeCounts = action.payload
        },
        setCTBadgeCounts: (state, action) => {
            state.ctBadgeCounts = action.payload
        },
        setSelectedBadge: (state, action) => {
            state.selectedBadge = action.payload
        },
        setRedeemRewardLoading: (state, action) => {
            state.redeemRewardLoading = action.payload
        },
        setRedeemReward: (state, action) => {
            state.redeemedReward = action.payload
        },
        setRedeemRewardError: (state, action) => {
            state.redeemedRewardError = action.payload
        },
        setWalletData: (state, action) => {
            state.walletData = action.payload
        },
        setCtEncryptedId: (state, action) => {
            state.ctEncryptedId = action.payload
        },
        setHasVoting: (state, action) => {
            state.hasVoting = action.payload
            localStorage.setItem('hasVoting', state.hasVoting ? "1" : "0");
            console.log("hasVoting:", state.hasVoting);
        },
        setPhoneNumber: (state, action) => {
            state.phoneNumber = action.payload
        },
        setTermsAndConditions: (state, action) => {
            state.termsAndConditions = action.payload
        },
        setInvalidPhoneNumber: (state, action) => {
            state.invalidPhoneNumber = action.payload
        },
        setPollSubmissionSuccess: (state, action) => {
            state.pollSubmissionSuccess = action.payload
        },
        setPollSubmissionError: (state, action) => {
            state.pollSubmissionError = action.payload
        },
        setPollSubmissionResults: (state, action) => {
            state.pollSubmissionResults = action.payload
        },
        setQuizUserSelection: (state, action) => {
            state.quizUserSelections = action.payload
        },
        setQuizSubmissionSuccess: (state, action) => {
            state.quizSubmissionSuccess = action.payload
        },
        setQuizSubmissionError: (state, action) => {
            state.quizSubmissionError = action.payload
        },
        setSeeAllBadgesModalActive: (state, action) => {
            state.seeAllBadgesModalActive = action.payload
        },
        setSelectedBadgeModalActive: (state, action) => {
            state.selectedBadgeModalActive = action.payload
        },
        setSurveyUserSelection: (state, action) => {
            state.surveyUserSelections = action.payload
        },
        setSurveySubmissionSuccess: (state, action) => {
            state.surveySubmissionSuccess = action.payload
        },
        setSurveySubmissionError: (state, action) => {
            state.surveySubmissionError = action.payload
        },
        setSurveyNoTextError: (state, action) => {
            state.surveyNoTextError = action.payload
        },
        setIsMobileView: (state, action) => {
            state.isMobileView = action.payload
        },
        setWindowSize: (state, action) => {
            state.windowSize = action.payload
        },
        setMemberSince: (state, action) => {
            state.memberSince = action.payload
        },
        setIsVIP: (state, action) => {
            state.isVIP = action.payload
        },
        setChallengeData: (state, action) => {
            state.challengeData = action.payload
        },
        setChallengesLoading: (state, action) => {
            state.challengesLoading = action.payload
        },
        setSelectedChallenge: (state, action) => {
            state.selectedChallenge = action.payload
        },
        setJoiningChallenge: (state, action) => {
            state.joiningChallenge = action.payload
        },
        setEventCheckin: (state, action) => {
            state.eventCheckin = action.payload
        },
        setSelectFavTeamModalOpen: (state, action) => {
            state.selectFavTeamModalOpen = action.payload
        },
        setShowNotification: (state, action) => {
            state.showNotification = action.payload
        },
        setNotificationBody: (state, action) => {
            state.notificationBody = action.payload
        },
    }
});

export const {
    setTabSelected, setUserLoading, setRewardsLoading, setNeedsBadges, setNeedsCTBadges,
    setBadgesLoading, setUserEmail, setUserGuid, setFavoriteTeams, setUserName, setRewardSections, setVotingSections, setGamesSections, setBadgeSections, setBadgeCounts, setRedeemRewardLoading,
    setRedeemReward, setRedeemRewardError, setWalletData, setCtEncryptedId, setHasVoting, setPhoneNumber, setTermsAndConditions, setInvalidPhoneNumber,
    setPollSubmissionSuccess, setPollSubmissionError, setPollSubmissionResults, setQuizUserSelection, setQuizSubmissionSuccess,
    setQuizSubmissionError, setSelectedBadge, setSeeAllBadgesModalActive, setSelectedBadgeModalActive, setSurveyUserSelection, setSurveySubmissionSuccess,
    setSurveySubmissionError, setSurveyNoTextError, setIsMobileView, setWindowSize, setMemberSince, setIsVIP, setCTBadgeCounts, setCTBadgeSections,
    setChallengeData, setChallengesLoading, setSelectedChallenge, setJoiningChallenge, setEventCheckin, setSelectFavTeamModalOpen, setShowNotification, setNotificationBody, setUserType
} = dataSlice.actions;

export default dataSlice.reducer;
